import React from 'react';

const PrinterFooter = () => {
  return (
    <div>

    </div>
  );
};

export default PrinterFooter;
